module.exports = __webpack_public_path__ + "assets/ic_weather04.2a2eac0e.svg";